import { useCallback, useLayoutEffect } from 'react'

import { useOpenedFolders } from 'components/FilesTree/hooks/useOpenedFolders'
import { OPEN_FOLDERS_STORAGE_KEY } from 'redux/constants'

export enum ExpandableTree {
  Folders = 'folders-tree',
  Favorites = 'favorites-tree',
  Projects = 'projects-tree',
  Configure = 'configure-tree',
}

const useExpandable = (folderKey: ExpandableTree) => {
  const { openFolderIds, openFolders, closeFolder } = useOpenedFolders()
  const expanded = openFolderIds.includes(folderKey)

  // Auto expand sections the first time the user logs in (when the localStorage has nothing in it)
  useLayoutEffect(() => {
    if (!localStorage.getItem(OPEN_FOLDERS_STORAGE_KEY)) {
      openFolders(Object.values(ExpandableTree))
    }
  }, [openFolders])

  const toggle = useCallback(() => {
    if (expanded) {
      closeFolder(folderKey)
    } else {
      openFolders([folderKey])
    }
  }, [closeFolder, expanded, folderKey, openFolders])

  return {
    toggle,
    expanded,
  }
}

export { useExpandable }
